import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBorcCekSenetList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBorcCekSenetList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Boss_VDebitCheques: any[];
  Boss_VDebitCheques_dummy: any[];
  Boss_VDebitChequesTotal: any[];
  Boss_VDebitChequesTotal_dummy: any[];
  GetVendorAccounts: any[];
  GetVendorAccounts_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class BorcCekSenetList_ScreenBase extends React.PureComponent<
  IBorcCekSenetList_ScreenProps,
  any
> {
  borcceksenetlist_411475_value_kuikaSelectBoxRef: React.RefObject<any>;
  borcceksenetlist_760966_value_kuikaAutoCompleteRef: React.RefObject<any>;
  borcceksenetlist_888430_value_kuikaTableRef: React.RefObject<any>;
  borcceksenetlist_611762_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9db17248-c3c1-4344-b817-1ebc24552816",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 981251, PropertyName: "label", Value: "Profil" },
        { Id: 430881, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 909156, PropertyName: "value", Value: "Borç Çek/Senet" },
        { Id: 411475, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 760966, PropertyName: "placeholder", Value: "Cari Ünvanı..." },
        { Id: 621226, PropertyName: "value", Value: "Toplam Çek Sayısı" },
        { Id: 887540, PropertyName: "value", Value: "adet" },
        { Id: 93650, PropertyName: "value", Value: "Toplam Tutar" },
        {
          Id: 888430,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 328486, PropertyName: "title", Value: "Title" },
        { Id: 857634, PropertyName: "value", Value: "Tipi" },
        { Id: 161875, PropertyName: "value", Value: "[datafield:tipi]" },
        { Id: 129259, PropertyName: "value", Value: "Tarih" },
        { Id: 77338, PropertyName: "value", Value: "[datafield:tarih]" },
        { Id: 450540, PropertyName: "value", Value: "Vade Tarihi" },
        { Id: 936610, PropertyName: "value", Value: "[datafield:vade]" },
        { Id: 375257, PropertyName: "value", Value: "Cari Ünvanı" },
        { Id: 315184, PropertyName: "value", Value: "[datafield:cariunvani]" },
        { Id: 320295, PropertyName: "value", Value: "Çek No" },
        { Id: 390013, PropertyName: "value", Value: "[datafield:cekno]" },
        { Id: 534715, PropertyName: "value", Value: "Tutar" },
        { Id: 872155, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 484923, PropertyName: "value", Value: "Durum" },
        { Id: 176436, PropertyName: "value", Value: "[datafield:durumu]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.borcceksenetlist_411475_value_kuikaSelectBoxRef = React.createRef();
    this.borcceksenetlist_760966_value_kuikaAutoCompleteRef = React.createRef();
    this.borcceksenetlist_888430_value_kuikaTableRef = React.createRef();
    this.borcceksenetlist_611762_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Boss_VDebitCheques: [],
      Boss_VDebitChequesTotal: [],
      GetVendorAccounts: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_411475: [
        { key: "Hepsi", text: "Hepsi" },
        { key: "Çek", text: "Çek" },
        { key: "Senet", text: "Senet" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("borcceksenetlist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BorcCekSenetListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("borcceksenetlist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("borcceksenetlist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BorcCekSenetListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      borcceksenetlist_525834_value:
        this.state.GetImage?.at?.(0)?.photo ?? undefined,
      borcceksenetlist_760966_value:
        this.state.GetVendorAccounts?.at?.(0)?.currAccCode ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BorcCekSenetListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      type_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BorcCekSenetList/BorcCekSenetListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VDebitCheques = result?.data.boss_VDebitCheques;

    stateVars.Boss_VDebitChequesTotal = result?.data.boss_VDebitChequesTotal;
    formVars.borcceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].cekAdeti
        : null
    );
    formVars.borcceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].tutar
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].tutar
        : null
    );
    stateVars.GetVendorAccounts = result?.data.getVendorAccounts;

    formVars.borcceksenetlist_760966_value =
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null;
    formVars.borcceksenetlist_760966_options = stateVars.GetVendorAccounts;
    stateVars.GetImage = result?.data.getImage;
    formVars.borcceksenetlist_525834_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BorcCekSenetListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BorcCekSenetListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.borcceksenetlist_525834_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.borcceksenetlist_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    formVars.borcceksenetlist_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    formVars.borcceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].cekAdeti
        : null
    );

    formVars.borcceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].tutar
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].tutar
        : null
    );

    stateVars.dataSource_888430 =
      stateVars.Boss_VDebitCheques ?? this.state.Boss_VDebitCheques;
    formVars.borcceksenetlist_611762_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].totalCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].totalCount
        : null
    );
    formVars.borcceksenetlist_611762_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].pageCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].pageCount
        : null
    );

    formVars.borcceksenetlist_611762_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].totalCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].totalCount
        : null
    );
    formVars.borcceksenetlist_611762_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].pageCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BorcCekSenetListComponent_548561_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BorcCekSenetList",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "252373",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BorcCekSenetListComponent_981251_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BorcCekSenetList",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BorcCekSenetListComponent_430881_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BorcCekSenetListComponent_411475_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BorcCekSenetList/BorcCekSenetListComponent_411475_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VDebitCheques = result?.data.boss_VDebitCheques;

    stateVars.Boss_VDebitChequesTotal = result?.data.boss_VDebitChequesTotal;
    formVars.borcceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].cekAdeti
        : null
    );
    formVars.borcceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].tutar
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BorcCekSenetListComponent_411475_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BorcCekSenetListComponent_411475_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "borcceksenetlist_611762_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.borcceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].cekAdeti
        : null
    );

    formVars.borcceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].tutar
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].tutar
        : null
    );

    stateVars.dataSource_888430 =
      stateVars.Boss_VDebitCheques ?? this.state.Boss_VDebitCheques;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BorcCekSenetListComponent_760966_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BorcCekSenetList/BorcCekSenetListComponent_760966_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VDebitCheques = result?.data.boss_VDebitCheques;

    stateVars.Boss_VDebitChequesTotal = result?.data.boss_VDebitChequesTotal;
    formVars.borcceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].cekAdeti
        : null
    );
    formVars.borcceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].tutar
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BorcCekSenetListComponent_760966_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BorcCekSenetListComponent_760966_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "borcceksenetlist_611762_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.borcceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].cekAdeti
        : null
    );

    formVars.borcceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VDebitChequesTotal !== undefined
        ? stateVars.Boss_VDebitChequesTotal?.length > 0
          ? stateVars.Boss_VDebitChequesTotal[0].tutar
          : null
        : this.state.Boss_VDebitChequesTotal?.length > 0
        ? this.state.Boss_VDebitChequesTotal[0].tutar
        : null
    );

    stateVars.dataSource_888430 =
      stateVars.Boss_VDebitCheques ?? this.state.Boss_VDebitCheques;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BorcCekSenetListComponent_611762_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "borcceksenetlist_611762_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BorcCekSenetList/BorcCekSenetListComponent_611762_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VDebitCheques = result?.data.boss_VDebitCheques;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BorcCekSenetListComponent_611762_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BorcCekSenetListComponent_611762_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_888430 =
      stateVars.Boss_VDebitCheques ?? this.state.Boss_VDebitCheques;
    formVars.borcceksenetlist_611762_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].totalCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].totalCount
        : null
    );
    formVars.borcceksenetlist_611762_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].pageCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].pageCount
        : null
    );

    formVars.borcceksenetlist_611762_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].totalCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].totalCount
        : null
    );
    formVars.borcceksenetlist_611762_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VDebitCheques !== undefined
        ? stateVars.Boss_VDebitCheques?.length > 0
          ? stateVars.Boss_VDebitCheques[0].pageCount
          : null
        : this.state.Boss_VDebitCheques?.length > 0
        ? this.state.Boss_VDebitCheques[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [252373] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BorcCekSenetListPageInit();
    }
  }
}
